import { render, staticRenderFns } from "./ObjectTable.vue?vue&type=template&id=6b5d56a4&scoped=true"
import script from "./ObjectTable.vue?vue&type=script&lang=js"
export * from "./ObjectTable.vue?vue&type=script&lang=js"
import style0 from "./ObjectTable.vue?vue&type=style&index=0&id=6b5d56a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d56a4",
  null
  
)

export default component.exports